function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.974 11.385l-1.583-5.697a7.768 7.768 0 00-15.066.395L.1 11.596a4.167 4.167 0 004.068 5.07h.928a4.167 4.167 0 008.167 0h.698a4.166 4.166 0 004.015-5.281zm-8.796 6.948a2.5 2.5 0 01-2.346-1.666h4.693a2.5 2.5 0 01-2.347 1.666zm6.772-4.32a2.48 2.48 0 01-1.99.987H4.166a2.499 2.499 0 01-2.44-3.043l1.225-5.513a6.1 6.1 0 0111.833-.31l1.584 5.697a2.481 2.481 0 01-.419 2.181z"
});

function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21"
  }, props), _ref);
}

export default SvgBellIcon;